module.exports = __webpack_public_path__ + "img/auto-onboard-template-136px.8bbb374.png";